(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[29],{

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "3Fn9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/InspirationalDescription.jsx


var __jsx = react_default.a.createElement;





var InspirationalDescription_InspirationalDescription = function InspirationalDescription(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description,
      centered = _ref.centered;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  if (!title && !subtitle && !description) {
    return null;
  }

  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('leading-1', {
      'text-center sm:pb-95 max-w-3/5 mx-auto': centered,
      'direction-rtl': isRTL
    })
  }, __jsx(Title["a" /* Title */], {
    theme: "none",
    className: "text-24 font-brand",
    hLevel: 3
  }, title), __jsx(Text["a" /* Text */], {
    className: "text-16 font-bold",
    text: subtitle,
    theme: "none"
  }), __jsx(Text["a" /* Text */], {
    className: "text-16",
    text: description,
    theme: "none"
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Img.jsx + 1 modules
var Img = __webpack_require__("X6TF");

// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/InspirationalPicture.jsx









var InspirationalPicture_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var InspirationalPicture_InspirationalPicture = function InspirationalPicture(_ref) {
  var className = _ref.className,
      descriptionStyle = _ref.descriptionStyle,
      _ref$disableRelativeP = _ref.disableRelativePadding,
      disableRelativePadding = _ref$disableRelativeP === void 0 ? false : _ref$disableRelativeP,
      imgClassName = _ref.imgClassName,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$isWide = _ref.isWide,
      isWide = _ref$isWide === void 0 ? false : _ref$isWide,
      link = _ref.link,
      radius = _ref.radius,
      ratioDisplay = _ref.ratioDisplay,
      ratioKey = _ref.ratioKey,
      subtitle = _ref.subtitle,
      title = _ref.title,
      url = _ref.url;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var track = Object(useTracking["a" /* useTracking */])();
  var padding = isWide ? 'calc(20 / 1440 * 100vw)' : 'min(1.25rem, calc(20 / 1180 * 100vw))';

  var descriptionText = InspirationalPicture_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full items-center p-20 text-white', {
      'direction-rtl': isRTL
    }),
    "data-testid": "IG-item-".concat(index, "-link"),
    style: !disableRelativePadding ? {
      padding: padding
    } : {}
  }, InspirationalPicture_jsx("span", null, title, subtitle && InspirationalPicture_jsx(react["Fragment"], null, InspirationalPicture_jsx("br", null), InspirationalPicture_jsx("span", {
    className: "font-sans text-12 sm:text-10 lg:text-12"
  }, subtitle))), link && InspirationalPicture_jsx("span", {
    className: "transition-transform ms-auto transform ps-5 duration-250 ease-in group-hover:ltr:translate-x-1/2 rtl:-translate-x-1/2"
  }, InspirationalPicture_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    hasRtl: true,
    width: "0.625rem"
  })));

  var content = InspirationalPicture_jsx(react["Fragment"], null, InspirationalPicture_jsx(Img["a" /* Img */], {
    altMsg: title,
    className: Object(classnames_utils["a" /* classnames */])(imgClassName, {
      'transition-transform transform duration-250 ease-in group-hover:scale-105 group-focus:scale-105': link
    }),
    ratioDisplay: ratioDisplay,
    ratioKey: ratioKey,
    url: url
  }), title && InspirationalPicture_jsx("div", {
    className: "absolute inset-0 flex items-end bg-[linear-gradient(0deg,rgba(0,0,0,0.8)_0%,transparent_100px)] font-brand text-16 leading-tight sm:text-14 lg:text-16",
    style: _objectSpread({}, descriptionStyle)
  }, descriptionText));

  return InspirationalPicture_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('group relative isolate overflow-hidden', {
      'rounded-12': !radius
    }, className),
    "data-testid": "IG-item-".concat(index),
    style: radius && {
      borderRadius: radius + 'px'
    }
  }, link ? InspirationalPicture_jsx(DynamicLink["a" /* default */], {
    className: "w-full",
    onClick: function onClick() {
      return track({
        actionGA: 'inspirationalGrid',
        categoryGA: 'landing',
        labelGA: title,
        thumbnailPosition: index + 1
      });
    },
    target: "_blank",
    url: link
  }, content) : content);
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridFancy.jsx



var InspirationalGridFancy_jsx = react_default.a.createElement;





var InspirationalGridFancy_InspirationalGridFancy = function InspirationalGridFancy(_ref) {
  var pictures = _ref.pictures,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description;
  var containerStyles = getContainerStyles(FANCY_CONTAINER_RATIO);
  var leftPanelContentStyles = 'w-[calc(530/1440*100%)]';
  var centerPanelContentStyles = 'w-[calc(480/1440*100%)]';
  var rightPanelContentStyles = 'w-[calc(430/1440*100%)]';
  var relativePadding = 'p-[calc(20/1440*100vw)]';
  var shouldDisplayInlineDescription = pictures.length < 5;
  var offsetIndex = shouldDisplayInlineDescription ? 1 : 0;

  var editorialZone = InspirationalGridFancy_jsx(InspirationalDescription_InspirationalDescription, {
    title: title,
    subtitle: subtitle,
    description: description,
    centered: !shouldDisplayInlineDescription
  });

  return InspirationalGridFancy_jsx(react["Fragment"], null, !shouldDisplayInlineDescription && editorialZone, InspirationalGridFancy_jsx("div", {
    className: "relative h-0 w-full",
    style: containerStyles
  }, InspirationalGridFancy_jsx("div", {
    className: "absolute inset-0 flex overflow-hidden"
  }, shouldDisplayInlineDescription ? InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex h-full items-center justify-center', leftPanelContentStyles)
  }, InspirationalGridFancy_jsx("div", {
    className: "w-full max-w-3/5"
  }, editorialZone)) : InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex h-full items-end justify-end', leftPanelContentStyles)
  }, InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-[calc(820/530*100%)] shrink-0 rounded-12 bg-white', relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    descriptionStyle: {
      paddingLeft: 'calc(280 / 820 * 100%)'
    },
    ratioDisplay: 780 / 1440 // $FlowFixMe

  }, pictures[0 - offsetIndex], {
    index: 0 - offsetIndex + 1
  })))), InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative z-1 flex h-full flex-col items-end', centerPanelContentStyles)
  }, InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('mx-auto shrink-0 rounded-2 bg-white', 'w-[calc(320/480*100%)]', relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    ratioDisplay: 280 / 1440 // $FlowFixMe

  }, pictures[1 - offsetIndex], {
    index: 1 - offsetIndex + 1
  }))), InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('shrink-0 rounded-12 bg-white', 'mr-[calc(-120/480*100%)] w-[calc(420/480*100%)]', relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    ratioDisplay: 380 / 1440 // $FlowFixMe

  }, pictures[2 - offsetIndex], {
    index: 2 - offsetIndex + 1
  })))), InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex h-full flex-col', rightPanelContentStyles)
  }, InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('shrink-0 rounded-12 bg-white', 'w-[calc(620/430*100%)]', relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    descriptionStyle: {
      paddingLeft: 'calc((420% / 480 * 100) * (120 / 480) * (430 / 620) * (480 / 430))',
      // I'm gonna need you to trust me
      paddingRight: 'calc(180 / 620 * 100%)' // same

    },
    ratioDisplay: 580 / 1440 // $FlowFixMe

  }, pictures[3 - offsetIndex], {
    index: 3 - offsetIndex + 1
  }))), InspirationalGridFancy_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('shrink-0 rounded-12 bg-white', 'w-[calc(320/430*100%)]', relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    ratioDisplay: 280 / 1440 // $FlowFixMe

  }, pictures[4 - offsetIndex], {
    index: 4 - offsetIndex + 1
  })))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridFull.jsx

var InspirationalGridFull_jsx = react_default.a.createElement;



var InspirationalGridFull_InspirationalGridFull = function InspirationalGridFull(_ref) {
  var pictures = _ref.pictures;
  var containerStyles = getContainerStyles(FULL_CONTAINER_RATIO);
  return InspirationalGridFull_jsx("div", {
    className: "relative h-0 w-full",
    style: containerStyles
  }, InspirationalGridFull_jsx("div", {
    className: "absolute inset-0 flex overflow-hidden"
  }, InspirationalGridFull_jsx("div", {
    className: "relative left-1/2 inline-flex shrink-0 -translate-x-1/2 transform"
  }, InspirationalGridFull_jsx("div", {
    className: "w-[calc(580/1440*100vw)]"
  }, InspirationalGridFull_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "h-full",
    descriptionStyle: {
      paddingLeft: 'calc(190 / 1440 * 100vw)'
    },
    ratioDisplay: 1 / 2,
    ratioKey: HORIZONTAL_RATIO // $FlowFixMe

  }, pictures[0], {
    index: 1,
    radius: 10
  }))), InspirationalGridFull_jsx("div", {
    className: "mx-[calc(40/1440*100vw)] my-0 w-[calc(580/1440*100vw)]"
  }, InspirationalGridFull_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "h-full",
    ratioDisplay: 1 / 2,
    ratioKey: HORIZONTAL_RATIO // $FlowFixMe

  }, pictures[1], {
    index: 2,
    radius: 10
  }))), InspirationalGridFull_jsx("div", {
    className: "w-[calc(580/1440*100vw)]"
  }, InspirationalGridFull_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "h-full",
    descriptionStyle: {
      paddingRight: 'calc(190 / 1440 * 100vw)'
    },
    ratioDisplay: 1 / 2,
    ratioKey: HORIZONTAL_RATIO // $FlowFixMe

  }, pictures[2], {
    index: 3,
    radius: 10
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridVertical.jsx

var InspirationalGridVertical_jsx = react_default.a.createElement;



var InspirationalGridVertical_InspirationalGridVertical = function InspirationalGridVertical(_ref) {
  var pictures = _ref.pictures;
  var containerStyles = getContainerStyles(VERTICAL_CONTAINER_RATIO);

  var spacer = InspirationalGridVertical_jsx("div", {
    className: "h-full w-[calc(20/1180*100%)] shrink-0"
  });

  return InspirationalGridVertical_jsx("div", {
    className: "relative h-0 w-full",
    style: containerStyles
  }, InspirationalGridVertical_jsx("div", {
    className: "absolute inset-0 flex justify-between"
  }, InspirationalGridVertical_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "w-full",
    ratioDisplay: 1 / 3,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[0], {
    index: 1
  })), spacer, InspirationalGridVertical_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "w-full",
    ratioDisplay: 1 / 3,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[1], {
    index: 2
  })), spacer, InspirationalGridVertical_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "w-full",
    ratioDisplay: 1 / 3,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[2], {
    index: 3
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridHorizontal.jsx



var InspirationalGridHorizontal_jsx = react_default.a.createElement;




var InspirationalGridHorizontal_InspirationalGridHorizontal = function InspirationalGridHorizontal(_ref) {
  var pictures = _ref.pictures,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description;
  var containerStyles = getContainerStyles(HORIZONTAL_CONTAINER_RATIO);
  var margin = {
    margin: '0 calc(20 / 1180 * 100%)'
  };
  return InspirationalGridHorizontal_jsx(react["Fragment"], null, InspirationalGridHorizontal_jsx(InspirationalDescription_InspirationalDescription, {
    title: title,
    subtitle: subtitle,
    description: description,
    centered: true
  }), InspirationalGridHorizontal_jsx("div", {
    className: "relative h-0 w-full",
    style: containerStyles
  }, InspirationalGridHorizontal_jsx("div", {
    className: "absolute inset-0 flex"
  }, InspirationalGridHorizontal_jsx("div", {
    className: "flex items-center"
  }, InspirationalGridHorizontal_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: VERTICAL_RATIO,
    ratioDisplay: 1 / 4 // $FlowFixMe

  }, pictures[0], {
    index: 1
  }))), InspirationalGridHorizontal_jsx("div", {
    className: "flex shrink-0",
    style: margin
  }, InspirationalGridHorizontal_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    imgClassName: "h-full",
    ratioDisplay: 1 / 2 // $FlowFixMe

  }, pictures[1], {
    index: 2
  }))), InspirationalGridHorizontal_jsx("div", {
    className: "flex items-center"
  }, InspirationalGridHorizontal_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: VERTICAL_RATIO,
    ratioDisplay: 1 / 4 // $FlowFixMe

  }, pictures[2], {
    index: 3
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridMainStage.jsx



var InspirationalGridMainStage_jsx = react_default.a.createElement;





var InspirationalGridMainStage_InspirationalGridMainStage = function InspirationalGridMainStage(_ref) {
  var description = _ref.description,
      pictures = _ref.pictures,
      subtitle = _ref.subtitle,
      title = _ref.title;
  var containerStyles = getContainerStyles(MAINSTAGE_CONTAINER_RATIO);
  var leftPanelContentStyles = 'w-[calc(280/1180*100%)]';
  var centerPanelContentStyles = 'w-[calc(355/1180*100%)]';
  var rightPanelContentStyles = leftPanelContentStyles;
  var margin = 'my-0 mr-[calc(20/1180*100%)] ml-auto';
  var shouldDisplayInlineDescription = pictures.length < 3;
  var offsetIndex = shouldDisplayInlineDescription ? 1 : 0;

  var editorialZone = InspirationalGridMainStage_jsx(InspirationalDescription_InspirationalDescription, {
    title: title,
    subtitle: subtitle,
    description: description,
    centered: !shouldDisplayInlineDescription
  });

  return InspirationalGridMainStage_jsx(react["Fragment"], null, !shouldDisplayInlineDescription && editorialZone, InspirationalGridMainStage_jsx("div", {
    className: "relative h-0 w-full",
    style: containerStyles
  }, InspirationalGridMainStage_jsx("div", {
    className: "absolute inset-0 flex"
  }, InspirationalGridMainStage_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('mr-auto flex items-center', leftPanelContentStyles)
  }, shouldDisplayInlineDescription ? editorialZone : InspirationalGridMainStage_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioDisplay: 280 / 1180,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[0 - offsetIndex], {
    index: 1
  }))), InspirationalGridMainStage_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('ml-auto flex', centerPanelContentStyles, margin)
  }, InspirationalGridMainStage_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioDisplay: 355 / 1180,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[1 - offsetIndex], {
    index: 2
  }))), InspirationalGridMainStage_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-center', rightPanelContentStyles)
  }, InspirationalGridMainStage_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioDisplay: 280 / 1180,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[2 - offsetIndex], {
    index: 3
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/InspirationalGrid.jsx




var InspirationalGrid_jsx = react_default.a.createElement;












var HORIZONTAL_RATIO = ratios_utils["c" /* default */].XL;
var VERTICAL_RATIO = ratios_utils["c" /* default */].R_65_BY_48;
var MAINSTAGE_CONTAINER_RATIO = 480 / 1180;
var HORIZONTAL_CONTAINER_RATIO = 380 / 1180;
var VERTICAL_CONTAINER_RATIO = MAINSTAGE_CONTAINER_RATIO;
var FULL_CONTAINER_RATIO = 365 / 1440;
var FANCY_CONTAINER_RATIO = 620 / 1440;
var getContainerStyles = function getContainerStyles(ratio) {
  return {
    paddingBottom: "calc(".concat(ratio, " * 100%)")
  };
};

var InspirationalGrid_getComponentFromLayout = function getComponentFromLayout(layout) {
  switch (layout) {
    case 'mainStage':
      return InspirationalGridMainStage_InspirationalGridMainStage;

    case 'horizontal':
      return InspirationalGridHorizontal_InspirationalGridHorizontal;

    case 'vertical':
      return InspirationalGridVertical_InspirationalGridVertical;

    case 'full':
      return InspirationalGridFull_InspirationalGridFull;

    case 'fancy':
      return InspirationalGridFancy_InspirationalGridFancy;

    default:
      return InspirationalGridMainStage_InspirationalGridMainStage;
  }
};

var InspirationalGrid_InspirationalGrid = function InspirationalGrid(_ref) {
  var layout = _ref.layout,
      pictures = _ref.pictures,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      _useResponsive$isBrow = _useResponsive.isBrowserGreaterThan,
      isBrowserGreaterThan = _useResponsive$isBrow === void 0 ? {
    XS: true
  } : _useResponsive$isBrow;

  var numberOfPictures = pictures.length;
  var actualLayout = layout;

  if (numberOfPictures === 2) {
    actualLayout = 'mainStage';
  } else if (numberOfPictures >= 4) {
    actualLayout = 'fancy';
  }

  var TagName = InspirationalGrid_getComponentFromLayout(actualLayout);
  var shouldShowDescription = numberOfPictures === 2 || numberOfPictures === 4 || actualLayout === 'horizontal';
  var editorialProps = shouldShowDescription || !isBrowserGreaterThan.XS ? {
    title: title,
    subtitle: subtitle,
    description: description
  } : {};
  return isBrowserGreaterThan.XS ? InspirationalGrid_jsx("div", {
    className: "direction-ltr"
  }, InspirationalGrid_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: actualLayout === 'full' || actualLayout === 'fancy'
  }, InspirationalGrid_jsx(TagName, Object(esm_extends["a" /* default */])({
    pictures: pictures
  }, editorialProps)))) : InspirationalGrid_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: true
  }, InspirationalGrid_jsx("div", {
    className: "px-20 pb-40"
  }, InspirationalGrid_jsx(InspirationalDescription_InspirationalDescription, editorialProps)), InspirationalGrid_jsx("div", {
    className: "scroll-x scrollbar-hidden flex snap-x snap-mandatory"
  }, pictures.map(function (picture, index) {
    return InspirationalGrid_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('w-[80vw] shrink-0 snap-start ps-15', {
        'me-15': index === pictures.length - 1
      }),
      key: index
    }, InspirationalGrid_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({}, picture, {
      ratioKey: VERTICAL_RATIO,
      ratioDisplay: 0.8,
      disableRelativePadding: true
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/inspirational-grid-line/InspirationalGridLine.jsx


var InspirationalGridLine_jsx = react_default.a.createElement;


var InspirationalGridLine_InspirationalGridLine = function InspirationalGridLine(_ref) {
  var description = _ref.description,
      layout = _ref.layout,
      pictures = _ref.pictures,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return InspirationalGridLine_jsx("div", {
    className: "Line",
    id: "inspirationalGrid"
  }, InspirationalGridLine_jsx(InspirationalGrid_InspirationalGrid, {
    description: description,
    layout: layout,
    pictures: pictures,
    subtitle: subtitle,
    title: title
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/inspirational-grid/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (InspirationalGridLine_InspirationalGridLine);

/***/ }),

/***/ "6Jj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductIntroductionActions; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("0IQ5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var ProductIntroductionActions = function ProductIntroductionActions(_ref) {
  var className = _ref.className,
      _ref$ratingImage = _ref.ratingImage,
      ratingImage = _ref$ratingImage === void 0 ? {} : _ref$ratingImage;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_2__[/* useTracking */ "a"])({
    actionGA: 'practicalInfos',
    categoryGA: 'resort',
    labelGA: 'tripAdvisorAnchor'
  });
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('flex flex-col items-center sm:items-stretch', className)
  }, ratingImage && ratingImage.src && __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
    className: "border-1 border-sand leading-0 p-5 rounded-12 text-center",
    onClick: function onClick() {
      return track();
    },
    url: "#tripadvisor"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_4__[/* Image */ "a"], {
    altMsg: ratingImage.alt,
    dontChangeAnything: true,
    imageUrl: ratingImage.src,
    ratioDisplay: 3 / 20
  })));
};

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return camelToSnakeCase; });
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}

var camelToSnakeCase = function camelToSnakeCase(str) {
  return str ? str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  }) : '';
};



/***/ })

}]);